<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rfB2ns/tc-custom/9783968651811.jpg?1703128626475" alt="This image is the cover for the book Weeds, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Weeds, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>First published in 1923, Weeds is set amid the tobacco tenant farms of rural Kentucky. This pioneering naturalist novel tells the story of a hard-working, spirited young woman who finds herself in a soul-destroying battle with the imprisoning duties of motherhood and of managing an impoverished household. The novel is particularly noteworthy for its heartbreaking depiction of a woman who suffers not from a lack of love, but from an unrequited longing for self-expression and freedom. (Goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edith Summers Kelley
      </h2>
      
      <p class="authorDescription body article">Edith Summers Kelley (April 28, 1884 – June 9, 1956) was a Canadian-born author who lived and worked in the United States, and is best known for her 1923 novel Weeds (1923), set in the hills of Kentucky. Weeds was conceived while she and Kelley lived on a tobacco farm in Scott County, Kentucky. It had some positive reviews but no commercial success; a second novel, The Devil's Hand, written while she and Kelley lived in Imperial Valley, California, was left unfinished, and was not printed until 1974.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0676aa7c